import axios from "axios";

axios.defaults.withCredentials = true;

// You can change the baseURL that depends on REST APIs url that your Server configures.
const BASEURL = process.env.REACT_APP_BASEURL;

// console.log("[info] BASEURL",BASEURL)

export default axios.create({
  baseURL: BASEURL,
  withCredentials: true
});